import { EmptyState, Button } from '@kollektive/design-system';
import { Wifi, AlertTriangle, RefreshCw } from 'lucide-react';
import type { TenantErrorType } from '@/context';
import styles from './TenantError.module.css';

interface TenantErrorProps {
  type: TenantErrorType;
  message: string;
  onRetry?: () => void;
}

export function TenantError({ type, message, onRetry }: TenantErrorProps) {
  const isNetworkError = type === 'network';

  return (
    <div className={styles.container}>
      <EmptyState
        variant="error"
        icon={isNetworkError ? <Wifi size={48} /> : <AlertTriangle size={48} />}
        title={isNetworkError ? 'Connection Error' : 'Something Went Wrong'}
        description={message}
        action={
          onRetry ? (
            <Button onClick={onRetry} iconLeft={<RefreshCw size={16} />}>
              Try Again
            </Button>
          ) : undefined
        }
      />
      <div className={styles.footer}>
        <p className={styles.footerText}>
          If this problem persists, please contact{' '}
          <a href="mailto:support@kollektive.ai" className={styles.link}>
            Kollektive support
          </a>
          .
        </p>
      </div>
    </div>
  );
}
